export const basePhrases = {
    'es-ES': 'Encuentra tu $accommodationName en $location, y accede a beneficios y atención personalizada para hacer más fácil tu mudanza.',
    'es-CL': 'Encuentra tu $accommodationName en $location, con atención personalizada para que tu mudanza sea más sencilla.',
    'es': 'Encuentra tu $accommodationName en $location, y disfruta de una atención personalizada para facilitar tu mudanza.',
    'en': 'Find your $accommodationName in $location and enjoy personalized services to make your move easier.',
};
